import { render } from "./book-appointment.vue?vue&type=template&id=4617549c"
import script from "./book-appointment.vue?vue&type=script&lang=js"
export * from "./book-appointment.vue?vue&type=script&lang=js"

import "./book-appointment.vue?vue&type=style&index=0&id=4617549c&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-team/_components/book-appointment.vue'],['render',render],['__file',"book-appointment.vue"]])

export default __exports__